import styled from 'styled-components'
import useGlobalSearch from '../../hooks/useGlobalSearch'
import User from '../User/User'
import Organization from '../Organization/Organization'
import searchIcon from '../../assets/images/search-icon.png'

const Box = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  margin: -7px 0 64px -35px;
  padding-right: 45px;

  & > * {
    margin: 35px 0 0 35px;
  }
`

const Left = styled.div`
  display: flex;

  & > *:not(:last-child) {
    margin-right: 35px;
  }
`

const Input = styled.input`
  min-width: 400px;
  background-color: var(--color-bg-input);
  padding: 16px 20px 16px 60px;
  color: #4b5882;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Roboto', Arial, sans-serif;
  background-image: url(${searchIcon});
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: 22px center;
  border: 2px solid transparent;
  outline: none;
  border-radius: 4px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &::placeholder {
    color: var(--color-text-secondary);
  }

  &:focus {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px rgba(151, 202, 111, 0.2);
    background-color: #fff;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  @media only screen and (max-width: 920px) {
    min-width: 300px;
    font-size: 14px;
  }

  @media only screen and (max-width: 600px) {
    min-width: 250px;
  }
`

const Header = () => {
  const { globalQuery, setGlobalQuery } = useGlobalSearch()

  return (
    <Box>
      <Left>
        <Input
          type='text'
          placeholder='Search for support cases'
          onChange={e => setGlobalQuery(e.target.value)}
          value={globalQuery}
          className='global-search'
        />
        <Organization />
      </Left>
      <User />
    </Box>
  )
}

export default Header
